import Vue, { KeepAlive } from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const Home = () => import('@/views/Home')
const Production = () => import('@/views/Production')
const Customer = () => import('@/views/Customer')
const ThreeNav = () => import('@/views/ThreeNav')
const FourNav = () => import('@/views/FourNav')
const FiveNav = () => import('@/views/FiveNav')
const SystemView = () => import('@/views/System')
const AboutUsView = () => import('@/views/AboutUs')
const ContactUsView = () => import('@/views/ContactUs')
const AboutUs = () => import('@/components/about_us/index.vue')
const CountactUs = () => import('@/components/about_us/contact.vue')
const SystemList = () => import('@/components/system/index.vue')
const SystemDetail = () => import('@/components/system/detail.vue')
const CustomerList = () => import('@/components/cooperation_customer/list.vue')
const CustomerDetail = () => import('@/components/cooperation_customer/detail.vue')
const Demo = () => import('@/views/Demo')
// const ProductionBrain = () => import('@/components/production/ProductionBrain.vue')

const ProductionList = () => import('@/components/production/index.vue')
const ProductionDetail = () => import('@/components/production/detail.vue')
const YunZhaoShang = () => import('@/components/yun_zhaoshang/index.vue')
const EnterInnovation = () => import('@/components/enter_innovation/index.vue')
const Consulting = () => import('@/components/consulting/index.vue')
const ReportList = () => import('@/components/report_list/index.vue')
const NewsDetails = () => import('@/components/report_list/NewsDetails.vue')
const NewsDetailsTwo = () => import('@/components/report_list/NewsDetailsTwo.vue')
const Realize = () => import('@/components/realize/index.vue')
const CompanyProfile = () => import('@/components/company_profile/index.vue')

const routes = [
  {
    path: '',
    redirect: '/home'
  },
  {
    path:'/home',
    component:Home
  },
  {
    path:'/production',
    component:Production,
    children:[
      {
        path:'1',
        component:ProductionList
      },
      {
        path:'2',
        component:ProductionList
      },
      {
        path:'3',
        component:ProductionList
      },
      {
        path:'4',
        component:ProductionList
      },
      {
        path:'5',
        component:ProductionList
      },
      {
        path:'6',
        component:ProductionList
      },
      {
        path:'7',
        component:ProductionList
      },
      {
        path:'8',
        component:ProductionList
      },
    ]
  },
  {
    path:'/productionDetail',
    component:Production,
    children:[
      {
        path:'1',
        component:ProductionDetail
      }
    ]
  },
  // {
  //   path:'/threenav',
  //   component:ThreeNav
  // },
  // {
  //   path:'/fournav',
  //   component:FourNav,
  //   children:[
  //     {
  //       path:'1',
  //       component:ReportList
  //     },
  //     {
  //       path:'2',
  //       component:ReportList
  //     },
  //     {
  //       path:'3',
  //       component:ReportList
  //     },
  //   ]
  // },
  {
    path:'/customer',
    component:Customer,
    children:[
      {
        path:'1',
        component:CustomerList,
        meta: {
          KeepAlive:false
        }
      },
      {
        path:'2',
        component:CustomerList,
        meta: {
          KeepAlive:false
        }
      },
      {
        path:'3',
        component:CustomerList,
        meta: {
          KeepAlive:false
        }
      }
    ]
  },
  {
    path:'/customerDetail',
    component:Production,
    children:[
      {
        path:'1',
        component:CustomerDetail
      }
    ]
  },
  {
    path:'/system',
    component:SystemView,
    children:[
      {
        path:'1',
        component:SystemList
      },
      {
        path:'2',
        component:SystemList
      },
      {
        path:'3',
        component:SystemList
      },
      {
        path:'4',
        component:SystemList
      },
      {
        path:'5',
        component:SystemList
      },
    ]
  },
  {
    path:'/systemDetail',
    component:SystemView,
    children:[
      {
        path:'1',
        component:SystemDetail
      }
    ]
  },
  {
    path:'/about',
    component:AboutUsView,
    children:[
      {
        path:'1',
        component:AboutUs
      }
    ]
  },
  {
    path:'/contact',
    component:ContactUsView,
    children:[
      {
        path:'1',
        component:CountactUs
      },
    ]
  },
  
  // {
  //   path:'/fivenav',
  //   component:FiveNav,
  //   children:[
  //     {
  //       path:'1',
  //       component:Realize
  //     },
  //     {
  //       path:'2',
  //       component:Realize
  //     },
  //     {
  //       path:'3',
  //       component:Realize
  //     },
  //     {
  //       path:'4',
  //       component:Realize
  //     }
  //   ]
  // },
  // {
  //   path:'/demo',
  //   component:Demo
  // },
  // {
  //   path:'/news_detail/1',
  //   component:NewsDetails
  // },
  // {
  //   path:'/news_detail/2',
  //   component:NewsDetailsTwo
  // }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})


// router.beforeEach((to, from, next) => {
//   console.log(to, from, "router****************")
//   next()
// })

export default router